/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FC, PropsWithChildren } from "react";

type Props = {
  legendTitle: string;
};

export const Field: FC<PropsWithChildren<Props>> = (props) => {
  const { children, legendTitle } = props;

  return (
    <fieldset css={rootStyle}>
      <legend css={legendStyle}>{legendTitle}</legend>
      {children}
    </fieldset>
  );
};

const rootStyle = css`
  border: none;
  margin: 0;
  padding: 0;
`;

const legendStyle = css`
  color: #000;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 16px;
`;
